import { render, staticRenderFns } from "./NewRatePlanForm.vue?vue&type=template&id=67c7a3ff&scoped=true&"
import script from "./NewRatePlanForm.vue?vue&type=script&lang=js&"
export * from "./NewRatePlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c7a3ff",
  null
  
)

export default component.exports